/**
 * File: aria-list.js
 *
 * Import and initialize functions for Get in Touch section
 */

export default {
  getInTouchSection: document.querySelector('.wwav-get-in-touch'),
  init() {
    if (this.getInTouchSection) {
      this.render();
    }
  },
  render() {
    const imageDiv = this.getInTouchSection.querySelector('.sc_promo_image');
    const address = this.getInTouchSection.dataset.imgAltText;
    const bgImg = imageDiv.style.backgroundImage;
    const imgSrc = bgImg.replace('url(','').replace(')','');
    imageDiv.innerHTML = `<img src=${imgSrc} style="width:100%;height:100%;object-fit:cover" alt="${address}" role="img" aria-label="${address}" tabindex="1">`
  },
};
